import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import {
  ButtonModule,
  FormModule,
  GridModule,
  IconModule,
  ModalComponent,
  SubscriptionTicketCardComponent,
  TextFieldComponent,
  TicketCardComponent,
} from '@yoimo/joymo-ui';

import { ParsePeriodicityPipe } from '@core/pipes';

import { InfoBlockComponent, ParsedTextBlockComponent } from 'shared-lib';
import { PricePipe } from 'shared-lib/core';

import { PaymentHandlerComponent } from './payment-handler/payment-handler.component';
import { TicketCouponComponent } from './ticket-coupon/ticket-coupon.component';
import { TicketOptionSelector } from './ticket-option-selector/ticket-option-selector.component';
import { TicketOptionsComponent } from './ticket-options.component';
import { CancellationsComponent } from '../cancellations/cancellations.component';
import { CapturePaymentMethodComponent } from '../payments/capture-payment-method/capture-payment-method.component';
import { OfferInstallmentsComponent } from '../payments/offer-installments/offer-installments.component';

@NgModule({
  declarations: [
    PaymentHandlerComponent,
    TicketCouponComponent,
    TicketOptionsComponent,
    TicketOptionSelector,
  ],
  imports: [
    ButtonModule,
    CommonModule,
    SubscriptionTicketCardComponent,
    TicketCardComponent,
    GridModule,
    ModalComponent,
    FormModule,
    IconModule,
    FormsModule,
    PricePipe,
    CancellationsComponent,
    TextFieldComponent,
    CapturePaymentMethodComponent,
    RouterModule,
    OfferInstallmentsComponent,
    ParsePeriodicityPipe,
    InfoBlockComponent,
    ParsedTextBlockComponent,
  ],
  exports: [TicketOptionsComponent, TicketOptionSelector],
})
export class TicketOptionsModule {}
